import './Overlay-e34594a5.css';

var classes = {"Overlay":"prc-Overlay-Overlay-dVyJl"};

export { classes as default };
